import React, {Component} from 'react';

import {Dialog, ValidatingInput} from '../../../widgets';
import {connect} from 'react-redux';
import actions from '../coupons.actions';
import {uiActions} from '../../../chrome';

import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';

import './EditCoupon.css';
import moment from 'moment';

class EditCoupon extends Component {
	render() {
		const {
			onUpdate,
			onCancel,
			coupon,
			onQuantityUpdate,
			onDescriptionUpdate,
			onExpiryDateUpdate,
			onProductLinkUpdate
		} = this.props;

		const dialogButtons = ['cancel', 'update'];

		return (
			<Dialog
				title="Edit Promotion"
				className="editCouponDialog"
				submitOnEnter={false}
				buttons={dialogButtons}
				onUpdate={onUpdate}
				onCancel={onCancel}
				emphasis="update">
				<ul className="AddCoupon">
					<li>
						<label>
							<h3>Description</h3>
							<textarea
								className="CommunityAddCoupon-entry"
								placeholder="e.g 20% off all electrical work."
								maxLength={200}
								rows="4"
								value={coupon.description || ''}
								onChange={onDescriptionUpdate}
							/>
						</label>
					</li>
					<li>
						<label>
							<h3>Expiry Date*</h3>
							<DatePicker
								selected={
									coupon.expiryDate && moment(coupon.expiryDate).isValid()
										? moment(coupon.expiryDate).toDate()
										: null
								}
								onChange={date => onExpiryDateUpdate(date ? moment(date) : null)}
								filterDate={day => !moment(day).isAfter(moment().add(30, 'd'), 'day')}
								dateFormat="dd/MM/yyyy"
								placeholderText="Promotion Expiry Date"
								readOnly
								required
							/>
						</label>
					</li>
					<li>
						<label>
							<h3>Code*</h3>
							<ValidatingInput
								type="text"
								className="couponCode"
								placeholder="Promotion Code"
								maxLength={256}
								value={coupon.code || ''}
								invalidMessage="Required"
								invalidTitle="Promotion code is required"
								validIcon=""
								readOnly={true}
							/>
							<p className="codeTip">
								A unique code that your customers can use to redeem your coupon. e.g use the code
								B2Me at checkout to redeem deal.
							</p>
						</label>
					</li>
					<li>
						<label>
							<h3>Quantity*</h3>
							<ValidatingInput
								type="text"
								className="quantity"
								placeholder="Total No. Of Coupons - e.g 10"
								invalidMessage="Required"
								invalidTitle="Quentity is required"
								validIcon=""
								onChange={onQuantityUpdate}
								value={coupon.quantity || ''}
							/>
							<p className="codeTip">Only numerical values are allowed.</p>
						</label>
					</li>
					<li>
						<label>
							<h3>Product/Service Link</h3>
							<ValidatingInput
								type="text"
								className="productLink"
								placeholder="e.g https://b2me.com.au/example"
								maxLength={1024}
								onChange={onProductLinkUpdate}
								value={coupon.productLink || ''}
							/>
							<p className="codeTip">
								A link to external webpage or product site to provide more details on service or
								product. (Leave empty if not applicable)
							</p>
						</label>
					</li>
					<li>
						<label>
							<h3>Terms</h3>
							<p className="codeTip">
								`By submitting this promotion, you expressly understand and agree that B2Me
								Australia or its related parties do not provide any approval, endorsement, warranty
								or guarantee, or assumes any liability or responsibility as to the approval,
								provision or redemption of goods arising out of this promotion. For more
								information, visit our website Terms and Conditions`. -{' '}
								<a
									className="terms_link"
									href="/terms201902_1.pdf"
									target="_blank"
									rel="noopener noreferrer">
									Terms of use
								</a>
							</p>
						</label>
					</li>
				</ul>
			</Dialog>
		);
	}
}

const mapStateToProps = state => {
	return {
		session: state.session,
		coupon: state.coupon.editing
	};
};

const mapDispatchToProps = dispatch => {
	return {
		onDescriptionUpdate: e => dispatch(actions.couponDescEditing({description: e.target.value})),
		onExpiryDateUpdate: updatedDate =>
			dispatch(actions.couponExpiryEditing({expiryDate: updatedDate})),
		onQuantityUpdate: e => dispatch(actions.couponQuantityEditing({quantity: e.target.value})),
		onProductLinkUpdate: e =>
			dispatch(actions.couponProductLinkEditing({productLink: e.target.value})),
		onUpdate: () => {
			dispatch(actions.persistEditedCoupon());
			dispatch(uiActions.uiModal(null));
		},
		onCancel: () => {
			dispatch(uiActions.uiModal(null));
		}
	};
};

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(EditCoupon);



// WEBPACK FOOTER //
// ./src/community/coupons/edit-coupon/EditCoupon.js